/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AccountNavContent_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AccountNav_viewer$ref: FragmentReference;
export type AccountNav_viewer = {|
  +$fragmentRefs: AccountNavContent_viewer$ref,
  +$refType: AccountNav_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "AccountNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNavContent_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c3ac0a44332509c1ef9d29b8c32a830c';
module.exports = node;
